export default __webpack_public_path__ + "static/media/checkmark-white.8af80ef2.svg";